<div class="d-flex justify-content-between align-items-center" mat-dialog-title>
    <h1 class="condensed mb-0">Indexeren</h1>
    <div class="dialog-close">
        <div class="fab small active" id="btn-cancel" mat-dialog-close="">
            <i class="fas fa-times"></i>
        </div>
    </div>
</div>
<div class="dialog-content flex-column" mat-dialog-content>
    <div class="d-flex w-100">
        <mat-slider
            [discrete]="true"
            [displayWith]="formatLabel"
            [max]="10"
            [min]="0.01"
            [showTickMarks]="false"
            [step]="0.01"
            class="w-100 mt-3 flex-fill me-4"
            color="primary">
            <input [(ngModel)]="precent" matSliderThumb/>
        </mat-slider>
        <mat-form-field appearance="fill" class="percent-input ">
            <mat-label>Index</mat-label>
            <mat-icon class="mt-2" fontIcon="percent" matSuffix></mat-icon>
            <input
                [(ngModel)]="precent"
                [decimalInput]="2"
                appDecimalInput
                matInput
                placeholder="index %"
                type="text">
            <mat-error>Dit veld is verplicht</mat-error>
        </mat-form-field>
    </div>
    <div class="d-flex align-items-center">
        <i class="fas fa-exclamation-triangle pe-3"></i>
        <small class="ps-2">
            Let op, de wijzigingen worden pas opgeslagen als u de prijzenlijst opslaat met de knop rechtsonder.
        </small>
    </div>
</div>
<div class="d-flex flex-wrap pt-2 justify-content-between" mat-dialog-actions>
    <button mat-button mat-dialog-close>
        Annuleren
    </button>
    <button (click)="apply()" color="primary" mat-raised-button>
        Indexatie toepassen
    </button>
</div>

